'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_sr_TupleXXL(es) {
  this.ff = null;
  this.ff = es;
  if ((es.a.length <= 22)) {
    $j_java$002elang$002e$002dObject.$m_sr_Scala3RunTime$().Sx();
  }
}
export { $c_sr_TupleXXL as $c_sr_TupleXXL };
$p = $c_sr_TupleXXL.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_sr_TupleXXL;
/** @constructor */
function $h_sr_TupleXXL() {
}
export { $h_sr_TupleXXL as $h_sr_TupleXXL };
$h_sr_TupleXXL.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.g = (function(n) {
  return this.ff.a[n];
});
$p.n = (function() {
  return this.ff.a.length;
});
$p.o = (function() {
  return "Tuple";
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$f_sc_IterableOnceOps__mkString__T__T__T__T($j_java$002elang$002e$002dObject.$m_s_Predef$().iy(this.ff), "(", ",", ")");
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().e7(this, (-889275714), null);
});
$p.f = (function(that) {
  if ((that instanceof $c_sr_TupleXXL)) {
    if ((this.ff === that.ff)) {
      return true;
    } else {
      if ((this.ff.a.length !== that.ff.a.length)) {
        return false;
      }
      var i = 0;
      while ((i < this.ff.a.length)) {
        var $x_2 = $j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$();
        var arr$3 = this.ff;
        var n = i;
        var $x_1 = arr$3.a[n];
        var arr$4 = that.ff;
        var n$1 = i;
        if ((!$x_2.c($x_1, arr$4.a[n$1]))) {
          return false;
        }
        i = ((1 + i) | 0);
      }
      return true;
    }
  } else {
    return false;
  }
});
$p.Y2 = (function() {
  return this.ff.x();
});
function $isArrayOf_sr_TupleXXL(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.g4)));
}
export { $isArrayOf_sr_TupleXXL as $isArrayOf_sr_TupleXXL };
var $d_sr_TupleXXL = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sr_TupleXXL, "scala.runtime.TupleXXL", ({
  g4: 1,
  b: 1,
  c: 1
}));
export { $d_sr_TupleXXL as $d_sr_TupleXXL };
